import React from 'react'
import { Link } from 'react-router-dom'
function ProductsDetailsSection3() {
  return (
    <>
      <div className="container-fluid px-5 bgg-col backSection14 py-5 backcolor1">
        {/* Heading Row */}
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h3 className="mb-0">Hijama Suction Gun</h3>
          <p className="text-dark mb-0 ">
          {/* <span className="d-flex justify-content-between align-items-center gap-1 ">View All<i className="bi bi-chevron-right viewAll"></i></span> */}
          </p>
          
        </div>

        {/* Product Cards */}
        

        <div className="row g-4">
        <div className="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
          <div className="card custom-card">
            <div className="position-relative d-inline-block">
            <img src="/Images/BlackHijama.webp" className="card-img-top " alt="Avatar" />
            <span className="badge bg-success position-absolute bottom-0 start-0 rounded-0">25% offer</span>
            </div>
            <div className="card-body text-start">
              <h6 className="card-title mb-1">Black Hijama Suction <br></br>Gun |</h6>
              <small className="mb-0">Cupping Vaccum Pump</small>
              <div className="d-flex align-items-center justify-content-start gap-2 ">
              <p className="card-text fw-bold text-success mb-0">₹180</p>
              <small className="text-decoration-line-through text-muted ">$7.19</small>
              </div>
             
              <div className="text-warning mb-1">
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-half"></i>
              </div>
                <Link to='/DetailsPage' className="text-decoration-none">
                            <div className="bg-col text-white fw-semibold py-2 mt-auto rounded d-flex justify-content-center align-items-center" role="button">
                                Add to Cart <span className="ms-2"><i className="bi bi-bag"></i></span>
                              </div>
                              </Link>
            </div>
          </div>
        </div>

        <div className="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
          <div className="card custom-card">
            <div className="position-relative d-inline-block">
            <img src="/Images/Hijama_Vaccum_Gun.webp" className="card-img-top" alt="Avatar" />
            <span className="badge bg-success position-absolute bottom-0 start-0 rounded-0">25% offer</span>
            </div>
            <div className="card-body text-start">
              <h6 className="card-title mb-1">Hijama Vaccum Gun (Milky White) </h6>
              <small className="mb-0">Hijama Vaccum Gun</small>
              <div className="d-flex align-items-center justify-content-start gap-2 ">
              <p className="card-text fw-bold text-success mb-0">₹160</p>
              <small className="text-decoration-line-through text-muted ">$7.19</small>
              </div>
             
              <div className="text-warning mb-1">
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-half"></i>
              </div>
                <Link to='/DetailsPage' className="text-decoration-none">
              <div className="bg-col text-white fw-semibold py-2 mt-auto rounded d-flex justify-content-center align-items-center" role="button">
                  Add to Cart <span className="ms-2"><i className="bi bi-bag"></i></span>
                </div>
                </Link>
            </div>
          </div>
        </div>

        <div className="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
          <div className="card custom-card">
            <div className="position-relative d-inline-block">
            <img src="/Images/Electric_Cupping.webp" className="card-img-top" alt="Avatar" />
            <span className="badge bg-success position-absolute bottom-0 start-0 rounded-0">25% offer</span>
            </div>
            <div className="card-body text-start">
              <h6 className="card-title mb-1">Electric Cupping Therapy Suction Gun |  </h6>
              <small className="mb-0"> Rechargeable Gun</small>
             <div className="d-flex align-items-center justify-content-start gap-2 ">
              <p className="card-text fw-bold text-success mb-0">₹1250</p>
              <small className="text-decoration-line-through text-muted ">$7.19</small>
              </div>
             
              <div className="text-warning mb-1">
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-half"></i>
              </div>
                <Link to='/DetailsPage' className="text-decoration-none">
              <div className="bg-col text-white fw-semibold py-2 mt-auto rounded d-flex justify-content-center align-items-center" role="button">
                  Add to Cart <span className="ms-2"><i className="bi bi-bag"></i></span>
                </div>
                </Link>
            </div>
          </div>
        </div>

        <div className="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
          <div className="card custom-card">
           
            <div className="position-relative d-inline-block">
            <img src="/Images/White_Premium_Abs.webp" className="card-img-top" alt="Avatar" />
            <span className="badge bg-success position-absolute bottom-0 start-0 rounded-0">25% offer</span>
            </div>
            <div className="card-body text-start">
              <h6 className="card-title mb-1">Hijama Vaccum Therapy<br></br> Gun | </h6>
              <small className="mb-0">White Premium Abs</small>
              <div className="d-flex align-items-center justify-content-start gap-2 ">
              <p className="card-text fw-bold text-success mb-0">₹349</p>
              <small className="text-decoration-line-through text-muted ">$7.19</small>
              </div>
             
              <div className="text-warning mb-1">
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-half"></i>
              </div>
               <Link to='/DetailsPage' className="text-decoration-none">
              <div className="bg-col text-white fw-semibold py-2 mt-auto rounded d-flex justify-content-center align-items-center" role="button">
                  Add to Cart <span className="ms-2"><i className="bi bi-bag"></i></span>
                </div>
                </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="row g-4 mt-2">
        <div className="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
          <div className="card custom-card">
            <div className="position-relative d-inline-block">
            <img src="/Images/Hijama5.webp" className="card-img-top " alt="Avatar" />
            <span className="badge bg-success position-absolute bottom-0 start-0 rounded-0">25% offer</span>
            </div>
            <div className="card-body text-start">
              <h6 className="card-title mb-1">Hijama Therapy Gun | Premium Imported Quality Strong Suction</h6>
              <small className="mb-0">Cupping Vaccum Pump</small>
              <div className="d-flex align-items-center justify-content-start gap-2 ">
              <p className="card-text fw-bold text-success mb-0">₹480</p>
              <small className="text-decoration-line-through text-muted ">$500</small>
              </div>
             
              <div className="text-warning mb-1">
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-half"></i>
              </div>
                <Link to='/DetailsPage' className="text-decoration-none">
                            <div className="bg-col text-white fw-semibold py-2 mt-auto rounded d-flex justify-content-center align-items-center" role="button">
                                Add to Cart <span className="ms-2"><i className="bi bi-bag"></i></span>
                              </div>
                              </Link>
            </div>
          </div>
        </div>

        <div className="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
          <div className="card custom-card">
            <div className="position-relative d-inline-block">
            <img src="/Images/Hijama6.webp" className="card-img-top" alt="Avatar" />
            <span className="badge bg-success position-absolute bottom-0 start-0 rounded-0">25% offer</span>
            </div>
            <div className="card-body text-start">
              <h6 className="card-title mb-1">Hijama Vaccum Gun | Premium Abs Imported Suction Gun</h6>
              <small className="mb-0">Hijama Vaccum Gun</small>
              <div className="d-flex align-items-center justify-content-start gap-2 ">
              <p className="card-text fw-bold text-success mb-0">₹160</p>
              <small className="text-decoration-line-through text-muted ">$7.19</small>
              </div>
             
              <div className="text-warning mb-1">
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-half"></i>
              </div>
                <Link to='/DetailsPage' className="text-decoration-none">
              <div className="bg-col text-white fw-semibold py-2 mt-auto rounded d-flex justify-content-center align-items-center" role="button">
                  Add to Cart <span className="ms-2"><i className="bi bi-bag"></i></span>
                </div>
                </Link>
            </div>
          </div>
        </div>

        {/* <div className="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
          <div className="card custom-card">
            <div className="position-relative d-inline-block">
            <img src="/Images/Electric_Cupping.webp" className="card-img-top" alt="Avatar" />
            <span className="badge bg-success position-absolute bottom-0 start-0 rounded-0">25% offer</span>
            </div>
            <div className="card-body text-start">
              <h6 className="card-title mb-1">Electric Cupping Therapy Suction Gun |  </h6>
              <small className="mb-0"> Rechargeable Gun</small>
             <div className="d-flex align-items-center justify-content-start gap-2 ">
              <p className="card-text fw-bold text-success mb-0">₹1250</p>
              <small className="text-decoration-line-through text-muted ">$7.19</small>
              </div>
             
              <div className="text-warning mb-1">
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-half"></i>
              </div>
                <Link to='/DetailsPage' className="text-decoration-none">
              <div className="bg-col text-white fw-semibold py-2 mt-auto rounded d-flex justify-content-center align-items-center" role="button">
                  Add to Cart <span className="ms-2"><i className="bi bi-bag"></i></span>
                </div>
                </Link>
            </div>
          </div>
        </div> */}

        {/* <div className="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
          <div className="card custom-card">
           
            <div className="position-relative d-inline-block">
            <img src="/Images/White_Premium_Abs.webp" className="card-img-top" alt="Avatar" />
            <span className="badge bg-success position-absolute bottom-0 start-0 rounded-0">25% offer</span>
            </div>
            <div className="card-body text-start">
              <h6 className="card-title mb-1">Hijama Vaccum Therapy<br></br> Gun | </h6>
              <small className="mb-0">White Premium Abs</small>
              <div className="d-flex align-items-center justify-content-start gap-2 ">
              <p className="card-text fw-bold text-success mb-0">₹349</p>
              <small className="text-decoration-line-through text-muted ">$7.19</small>
              </div>
             
              <div className="text-warning mb-1">
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-half"></i>
              </div>
               <Link to='/DetailsPage' className="text-decoration-none">
              <div className="bg-col text-white fw-semibold py-2 mt-auto rounded d-flex justify-content-center align-items-center" role="button">
                  Add to Cart <span className="ms-2"><i className="bi bi-bag"></i></span>
                </div>
                </Link>
            </div>
          </div>
        </div> */}
      </div>
      </div>
      
    </>
  )
}

export default ProductsDetailsSection3
